import { CustomEventWithDetail } from "./CustomEventWithDetail";
export class ViewRendered extends CustomEventWithDetail {
}
export class ViewMounted extends CustomEventWithDetail {
}
export class ViewUnmounted extends CustomEventWithDetail {
}
